import React, { useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./loader.css";

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

const ProgressBar = ({onComplete, loaderColor}) => {
  const [percentage, setPercentage] = useState(0);

  setTimeout(() => {
    if (percentage < 100)
      setPercentage(
        percentage +
          getRandomInt(
            Math.min(5, 100 - percentage),
            Math.min(15, 100 - percentage)
          )
      );
  }, 1000);

  if (percentage >= 100) {
    setTimeout(onComplete, 1000);
  }

  return (
    <CircularProgressbar
      value={percentage}
      text={`${percentage}%`}
      styles={buildStyles({
        pathColor: loaderColor
      })}
    />
  );
};

export { ProgressBar };
